import * as React from 'react';

import {
  Popover,
  PopoverAnchor,
  PopoverContent,
  PopoverDescription,
  PopoverHeader,
  PopoverTitle,
  PopoverTrigger,
} from './components/ui/popover.js';

export function DimePopover({ ...props }: Readonly<React.ComponentProps<typeof Popover>>) {
  return <Popover {...props} />;
}

export function DimePopoverTrigger({
  ...props
}: Readonly<React.ComponentProps<typeof PopoverTrigger>>) {
  return <PopoverTrigger {...props} />;
}

export function DimePopoverContent({
  ...props
}: Readonly<React.ComponentProps<typeof PopoverContent>>) {
  return <PopoverContent {...props} />;
}

export function DimePopoverAnchor({
  ...props
}: Readonly<React.ComponentProps<typeof PopoverAnchor>>) {
  return <PopoverAnchor {...props} />;
}

export function DimePopoverHeader({
  ...props
}: Readonly<React.ComponentProps<typeof PopoverHeader>>) {
  return <PopoverHeader {...props} />;
}

export function DimePopoverTitle({
  ...props
}: Readonly<React.ComponentProps<typeof PopoverTitle>>) {
  return <PopoverTitle {...props} />;
}

export function DimePopoverDescription({
  ...props
}: Readonly<React.ComponentProps<typeof PopoverDescription>>) {
  return <PopoverDescription {...props} />;
}
